import Marquee from "react-fast-marquee";
import { Star, BadgeCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { BRANDS, COMPANY } from "@/data/content";

// "Ils nous ont fait confiance" + marques de serrures (navy trust band)
export default function Brands() {
  return (
    <section data-testid="brands" className="py-20 md:py-24 bg-brand-navy">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-brand-gold">
              <span className="w-8 h-px bg-brand-gold" /> Ils nous ont fait confiance
            </span>
            <h2 className="mt-5 font-display font-semibold text-3xl md:text-5xl tracking-tight text-white leading-tight">
              Toutes les grandes marques de serrures
            </h2>
          </div>
          <div className="flex items-center gap-4 rounded-2xl bg-white/5 border border-white/10 px-6 py-4">
            <div className="font-display font-semibold text-4xl text-white leading-none">
              {COMPANY.rating}
            </div>
            <div>
              <div className="flex gap-0.5 text-brand-gold">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-current" />
                ))}
              </div>
              <div className="mt-1 text-xs uppercase tracking-[0.12em] text-white/60">
                {COMPANY.reviewsCount} avis · Google
              </div>
            </div>
          </div>
        </Reveal>

        {/* Brand pills */}
        <Reveal className="flex flex-wrap gap-3 mb-10">
          {BRANDS.map((b) => (
            <span
              key={b}
              className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2 text-sm font-medium text-white/90"
            >
              <BadgeCheck className="w-4 h-4 text-brand-gold" />
              {b}
            </span>
          ))}
        </Reveal>
      </div>

      {/* Moving marquee for craft */}
      <Reveal>
        <Marquee speed={35} gradient={false} pauseOnHover>
          {BRANDS.concat(BRANDS).map((b, i) => (
            <span
              key={i}
              className="mx-6 md:mx-10 font-display font-medium text-3xl md:text-5xl tracking-tight text-white/15 select-none"
            >
              {b}
              <span className="text-brand-gold/50 ml-6 md:ml-10">/</span>
            </span>
          ))}
        </Marquee>
      </Reveal>
    </section>
  );
}
